export default __webpack_public_path__ + "static/media/grafema_clivitalbio_18.10a56e7c.jpg";